import { Component, TemplateRef, ViewChild } from "@angular/core";
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { HandlingItemsDialogComponent, HandlingItemsDialogData } from './handling-items-dialog/handling-items-dialog.component';
import {
  CtActivateActionsConfiguration,
  CtBinaryOperator,
  CtButtonConfiguration,
  CtDatatableActionCustomConfiguration,
  CtDatatableConfiguration,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtModelOperator,
  CtModelService,
  MAT_RAISED_PRIMARY
} from "@ctsolution/ct-framework";
import { HandlingService } from "../handling.service";
import { ActivatedRoute, Router } from "@angular/router";
import { DEFAULT_DATATABLE_CONFIGURATION } from "../../../_core/constants";
import { Handling } from "../../../_core/classes/handling";
import { HandlingOriginEnum } from "../../../_core/enum/handling-origin.enum";
import { HandlingRouteData } from "../../../_core/route-data/handling.route-data";
import { LangDownloadFileConfiguration, WorkOrderRowsExportTypeVO } from "../../lang-download-file/lang-download-file.configuration";
import { ReportDownloadParameter } from "../../../_core/classes/report-download.parameter";
import { HandlingStateEnum } from "../../../_core/enum/handling-state.enum";
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { CtManagerService } from "../../../_core/lib/ct-manager.service";

@Component({
  selector: "app-handling-create-list",
  template: `

    <ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>

    <ng-template #downloadPdfButton let-value="value">

      <app-lang-download-file [configuration]="langDownloadFileConfiguration"
                              (onDownload)="downloadPdf(value, $event)"></app-lang-download-file>
    </ng-template>

    <ng-template #deliveryDateCell let-value="value" let-row="row">

      <p style="display: flex;align-items: center;">

        <mat-icon style="font-size: 21px" *ngIf="value && expiredHandlingDelivery(row)" color="warn">
          notification_important
        </mat-icon>

        {{ value | date: 'dd/MM/yy' }}

      </p>

    </ng-template>

    <ng-template #handlingStateCell let-value="value">

      <p style="display: flex;align-items: center;">

        <mat-icon style="font-size: 21px; color: green;" *ngIf="deliveredHandling(value)">
          task_alt
        </mat-icon>
        {{ ('handlingStates.' + value) | translate }}

      </p>

    </ng-template>

    <ng-template #legendTemplate>

    <ct-button *ngIf="handlingExportConfiguration.visible" [configuration]="exportDownloadAttachmentButton"></ct-button>
    
  </ng-template>
  

  `
})
export class HandlingListComponent {

  @ViewChild("downloadPdfButton") downloadPdfButton: TemplateRef<any> | null = null;
  @ViewChild("deliveryDateCell") deliveryDateCell: TemplateRef<any> | null = null;
  @ViewChild("handlingStateCell") handlingStateCell: TemplateRef<any> | null = null;

  configuration: CtModelConfiguration<HandlingListComponent> | null = null;

  langDownloadFileConfiguration: LangDownloadFileConfiguration = LangDownloadFileConfiguration
    .create()
    .setColor("primary")
    .setIcon("picture_as_pdf")
    .setButtonType('mat-icon-button');

  exportDownloadAttachmentButton: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setAction(() => this.downloadExcel())
    .setLabel("Esporta")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("download");

  @ViewChild("legendTemplate") legendTemplate: TemplateRef<any> | null = null;


  datatableConfiguration: CtDatatableConfiguration = DEFAULT_DATATABLE_CONFIGURATION();
  handlingExportConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);
  customHandlingListConfiguration: CTConfigurationModel = CTConfigurationModel.create().setVisible(false);
  

  constructor(
    private handlingService: HandlingService,
    private route: ActivatedRoute,
    private modelService : CtModelService<HandlingListComponent>,
    private router: Router,
    private managerService : CtManagerService,
    private dialog: MatDialog) {
  }

  expiredHandlingDelivery = (value: Handling): boolean => !this.deliveredHandling(value.HandlingState) && new Date().getTime() > new Date(value.DeliveryDate ?? -1).getTime();

  deliveredHandling = (value: HandlingStateEnum | null): boolean => value === HandlingStateEnum.Delivered;

  async ngAfterViewInit() {


    await this.managerService.getComponentOverride("handling", "handlingExportConfiguration", this.handlingExportConfiguration).then((component) => {
      return;
    });

    await this.managerService.getComponentOverride("handling", "customHandlingListConfiguration", this.customHandlingListConfiguration).then((component) => {
      return;
    });

    await this.managerService.getComponentOverride("handling", "langDownloadFileConfiguration", this.langDownloadFileConfiguration).then((component) => {
      return;
    })  

    this.datatableConfiguration
      .setCustomDatatableActionConfiguration(
        CtDatatableActionCustomConfiguration
          .create()
          .setTemplateOutlet(this.downloadPdfButton));

    this.constantOrigin()
      .then(origin => {


        const activateActions = CtActivateActionsConfiguration.create()
          .setDoubleClickCB((event: Handling) => this.router.navigate(["..", "edit", event.Oid!.toString()], { relativeTo: this.route }));
        this.datatableConfiguration.setActivateActionsConfiguration(activateActions);

        // ✅ Costruisci l'array delle operations in base alla configurazione
        const operations = [CtModelOperator.Update];
        if (this.customHandlingListConfiguration.allowOnCreate) {
          operations.push(CtModelOperator.Create);
        }
        // Mostra il bottone Detail solo se handlingDetailEnabled = true (default)
        if (this.customHandlingListConfiguration.handlingDetailEnabled) {
          operations.push(CtModelOperator.Detail);
        }

        const configuration = CtModelConfiguration
          .create<HandlingListComponent>()
          .setOperations(operations)
          .setRouteData(HandlingRouteData())
          .setOnDetail((event: Handling) => this.openItemsDialog(event))
          .setOnEdit((event: Handling) => this.router.navigate(["..", "edit", event.Oid!.toString()], { relativeTo: this.route }));

        configuration
          .setFieldsCustomTemplates([
            {
              prop: (origin['HandlingOrigin'] === HandlingOriginEnum.Supplier ? "LocationFrom" : "SupplierFrom"),
              visible: false
            },
            {
              prop: 'DeliveryDate',
              cellTemplate: this.deliveryDateCell
            },
            {
              prop: 'HandlingState',
              cellTemplate: this.handlingStateCell
            }
          ])
          .setCTDatatableConfiguration(this.datatableConfiguration)
          .setCustomLabel('createButtonLabel', origin['HandlingOrigin'] === HandlingOriginEnum.Supplier ? 'createOrder' : 'createHandling')
          .setLegendTemplate(this.legendTemplate)


        configuration
          .filterValues
          .addConstantFilter(
            CTModelDatatableFilter
              .create()
              .setField('HandlingOrigin')
              .setValue(origin['HandlingOrigin'])
              .setOperatorType(CtBinaryOperator.Equal)
          )

        this.configuration = configuration;

      });

  }

  downloadPdf(value?: { Oid: number | null }, lang?: any) {

    if (!value?.Oid) return;

    const parameter: ReportDownloadParameter = ReportDownloadParameter
      .create()
      .setHandlingOid(value.Oid)
      .setTemplateLanguage(lang.code ?? 'it')
      .setRowType(lang.rowType ?? WorkOrderRowsExportTypeVO.All)
      .setDirectDownload(false)
      .setOpenInBrowser(true)
      .setAction('HandlingPdf')
      .setLabelDownload(`handling${value.Oid}`);

    this.handlingService.downloadHandlingPDF(parameter);

  }

  constantOrigin(): Promise<{ [p: string]: any }> {

    return new Promise<{ [p: string]: any }>((resolve) => {

      const originPathValue: string | null = this.route.snapshot.paramMap.get("origin");
      const HandlingOrigin: HandlingOriginEnum = this.handlingService.getHandlingTypeByRouteValue(originPathValue);

      this.route
        .data
        .subscribe(data => {

          switch (HandlingOrigin) {

            case HandlingOriginEnum.Supplier:
              data['title'] = "CT_MENU.order";
              break;
            case HandlingOriginEnum.Location:
            default:
              data['title'] = "CT_MENU.handling";
              break;
          }

          resolve({ HandlingOrigin });

        });

    });

  }

    downloadExcel(){
  
      const body : CtModelDatatableOperators = CtModelDatatableOperators.create();

      if(!this.configuration) return;
  
      this.modelService.export(this.configuration, body, { action: 'ExportExcelHandling' })
  
    }

  protected readonly HandlingStateEnum = HandlingStateEnum;

  /**
   * Apre la modale di dettaglio articoli per l'ordine selezionato.
   * Gli ItemHandlings sono già presenti nell'oggetto Handling restituito dalla datatable.
   *
   * @param handling - L'oggetto Handling della riga cliccata
   */
  openItemsDialog(handling: Handling): void {

    const data: HandlingItemsDialogData = {
      handlingNumber: handling.Number,
      itemHandlings: handling.ItemHandlings ?? [],
      // Necessario per il calcolo del totale: Delivered usa Qty, gli altri stati usano StartQty
      handlingState: handling.HandlingState,
      // Array vuoto = mostra tutte le colonne (default backward compatible)
      visibleColumns: this.customHandlingListConfiguration.handlingDetailVisibleColumns
    };

    this.dialog.open(HandlingItemsDialogComponent, {
      data,
      width: '800px',
      maxWidth: '95vw'
    });

  }

}
